import { inject } from "@angular/core";
import { CanMatchFn, Route, Router, UrlSegment } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AuthService } from "../services/auth.service";

export const canActivateLogin: CanMatchFn = async () => {
    return new Promise<boolean>(async (resolve) => {
        const auth = inject(AuthService);
        const isLoggedInObservable = await auth.isLoggedIn();
        const loggedIn = await firstValueFrom(isLoggedInObservable);
        if (loggedIn) auth.forceMain();
        resolve(!loggedIn);
    });
};

// export const canActivateMain: CanMatchFn = async () => {
//     return new Promise<boolean>(async (resolve) => {
//         const isLoggedInObservable = await inject(AuthService).isLoggedIn();
//         const loggedIn = await firstValueFrom(isLoggedInObservable);
//         resolve(!!loggedIn);
//     });
// };

export const canActivateMain: CanMatchFn = async (route: Route, segments: UrlSegment[]) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    
    const isLoggedInObservable = await auth.isLoggedIn();
    const loggedIn = await firstValueFrom(isLoggedInObservable);
    
    if (loggedIn) {
        return true;
    }

    // 1. Reconstruimos la ruta a la que intentaba acceder
    const returnUrl = '/' + segments.map(s => s.path).join('/');
    
    // 2. Le pasamos los queryParams originales (si los hubiera)
    const currentNavigation = router.getCurrentNavigation();
    const queryParams = currentNavigation?.extractedUrl.queryParams || {};

    // 3. Devolvemos un UrlTree para redirigir al login enviando el returnUrl
    // Incluimos los queryParams originales dentro del returnUrl si es necesario, 
    // o simplemente pasamos el returnUrl limpio.
    return router.createUrlTree(['/login'], { 
        queryParams: { returnUrl: returnUrl, ...queryParams } 
    });
};
